module.exports = __webpack_public_path__ + "img/pchomeservice.0ad6f610.svg";